import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Select, Table } from "antd";
//Components
import FilterContainer from "../../../components/common/FilterContainer";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

import { useNavigate } from "react-router";
import { useAuthState } from "react-firebase-hooks/auth";
import { getDocs, collection, doc, query, where } from "firebase/firestore";
import { auth, db } from "../../../firebase";
import { toast } from "react-hot-toast";

const RecurringWorkOrdersRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod(
      "New Service Request",
      "1",
      "",
      "",
      "/maintenance/work-orders/service-requests/new"
    ),
    RightBarMethod(
      "New Recurring Work Order",
      "2",
      "",
      "",
      "/maintenance/recurring-work-orders/new"
    ),
  ]),

  RightBarMethod(
    " REPORTS",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [RightBarMethod("Work Order", "3", "", "", "")]
  ),
];

function RecurringWorkOrders() {
  const navigate = useNavigate();
  const [user, loading] = useAuthState(auth);
  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [recurringData, setRecurringData] = useState([]);
  const [properties, setProperties] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [filteredData, setFilteredData] = useState(recurringData);
  const [isLoading, setIsLoading] = useState(false);

  const [form] = Form.useForm();

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const fetchServiceRequests = async () => {
    setIsLoading(true)
    const serviceRequestRef = collection(
      db,
      "companies",
      companyName,
      "recurringWorkOrders"
    );
    const propertiesRef = collection(
      db,
      "companies",
      companyName,
      "properties"
    );
    const vendorRef = collection(db, "companies", companyName, "vendors");
    const snapShotData = await getDocs(propertiesRef);
    const fetchedProperties = snapShotData.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    const snapShotDataVendor = await getDocs(vendorRef);
    const fetchedVendors = snapShotDataVendor.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    try {
      const snapShot = await getDocs(serviceRequestRef);
      const fetchedData = snapShot.docs.map((doc) => {
        const workOrderId = doc.id;
        const workOrderData = doc.data();

        const matchingProperty = fetchedProperties.find(
          (property) =>
            property.id === workOrderData.details.propertyInfo.propertyId
        );

        const matchingVendor = fetchedVendors.find(
          (vendor) => vendor.id === workOrderData.details.vendorInfo.vendorId
        );

        if (matchingProperty || matchingVendor) {
          const propertyName = `${matchingProperty?.propertyNameAddress.propertyName}`;
          const vendorName = `${matchingVendor?.vendorInfo.firstName} ${matchingVendor?.vendorInfo.lastName}`;
          return {
            id: workOrderId,
            key: workOrderId,
            vendor: vendorName,
            ...workOrderData,
            property: propertyName,
          };
        }
      });
      setRecurringData(fetchedData);
      setFilteredData(fetchedData);

      console.log("fetchedDatafetchedData", fetchedData);
    } catch (err) {
      console.log("error", err);
    } finally{
    setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    fetchServiceRequests();
  }, [companyName, isCompanyNameFetched]);
  console.log("recurringData", recurringData);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchProperties = async () => {
      try {
        const companiesRef = collection(db, "companies");
        const companyDocRef = doc(companiesRef, companyName);
        const propertiesRef = collection(companyDocRef, "properties");
        const querySnapshot = await getDocs(propertiesRef);

        console.log("...", querySnapshot);

        const fetchedData = querySnapshot?.docs?.map((doc) => ({
          id: doc.id,
          value: doc?.data()?.propertyNameAddress?.propertyName,
          label: doc?.data()?.propertyNameAddress?.propertyName,
        }));

        setProperties(fetchedData);
        console.log(fetchedData, "fetching..");
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchProperties();
    console.log("usingg useEffect 1");
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchVendors = async () => {
      try {
        const companiesRef = collection(db, "companies");
        const companyDocRef = doc(companiesRef, companyName);
        const vendorsRef = collection(companyDocRef, "vendors");
        const querySnapshot = await getDocs(vendorsRef);

        console.log("...", querySnapshot);

        const fetchedVendors = querySnapshot?.docs?.map((doc) => ({
          id: doc.id,
          value: `${doc?.data()?.vendorInfo?.firstName}`,
          label: `${doc?.data()?.vendorInfo?.firstName}`,
          vendorContact: doc?.data()?.contact?.phoneNumbers[0]?.phoneNumber,
          vendorEmail: doc?.data()?.contact?.emails[0]?.email,
        }));

        setVendors(fetchedVendors);
        console.log(fetchedVendors, "fetching vendor");
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    console.log("useeffect");

    fetchVendors();
    console.log("usingg useEffect 1");
  }, [companyName, isCompanyNameFetched]);

  const propertyArr = [];
  properties?.forEach((element) => {
    propertyArr.push(element.value);
    console.log(element, "element");
  });
  const vendorArr = [];
  vendors?.forEach((element) => {
    vendorArr.push(element.value);
    console.log(element, "element");
  });

  const columns = [
    {
      title: "Vendor",
      dataIndex: "vendor",
      key: "vendor",
      render: (_, record) => (
        <span>{record.vendor ? record.vendor : "--"}</span>
      ),
    },
    {
      title: "Property",
      dataIndex: "property",
      key: "property",
      ellipsis: true,
      render: (_, record) => (
        <span>{record.property ? record.property : "--"}</span>
      ),
    },
    {
      title: "Repeats",
      dataIndex: "workOrderInfo.description",
      key: "repeats",
      render: (_, record) => (
        <span>
          {record.recurranceInformation?.repeats
            ? record.recurranceInformation?.repeats
            : "--"}
        </span>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (_, record) => (
        <span>
          {record.details?.workOrderInfo.description
            ? record.details?.workOrderInfo.description
            : "--"}
        </span>
      ),
    },
  ];

  const handleFormSubmit = () => {
    const formData = form.getFieldsValue();
    Object.keys(formData).forEach((field) => {
      if (formData[field] === undefined) {
        formData[field] = "";
      }
    });
    console.log(formData, "formData");

    const filteredDataSource = recurringData.filter(
      (record) =>
        // console.log(record, "record")
        (formData.properties === "" ||
          record.property
            .toLowerCase()
            .includes(formData.properties.toLowerCase())) &&
        (formData.vendor === "" ||
          record.vendor
            .toLowerCase()
            .includes(formData.vendor.toLowerCase()))
    );
    console.log("filtered data", filteredDataSource);
    setFilteredData(filteredDataSource);
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  console.log("filteredDatafilteredData", filteredData);
  return (
    <>
      <div>
        <PageHeading heading="Recurring Work Orders" />
        <Row>
          <Col span={24}>
            <FilterContainer heading="Filter recurring work orders by using any of the search filters below:">
              <Form
                name="basic"
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                }}
                autoComplete="off"
                colon={false}
                onFinish={handleFormSubmit}
                onFinishFailed={onFinishFailed}
                form={form}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item label="Properties" name="properties">
                      <Select
                        showSearch
                        allowClear
                        placeholder="Search by properties or property lists"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{
                          width: "100%",
                        }}
                        options={properties}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Vendor" name="vendor">
                      <Select
                        showSearch
                        allowClear
                        placeholder="Search by vendors or management company"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{
                          width: "100%",
                        }}
                        options={vendors}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item label=" ">
                  <Button type="primary" htmlType="submit">
                    Search
                  </Button>
                </Form.Item>
              </Form>
            </FilterContainer>
          </Col>
          <Col span={24} className="table-container">
            <Table
              columns={columns}
              dataSource={filteredData}
              loading={isLoading}
              onRow={(record) => {
                return {
                  onClick: () =>
                    navigate(
                      `/maintenance/recurring-work-orders/recurring-work-order/${record.id}`
                    ),
                };
              }}
            />
          </Col>
        </Row>

      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={RecurringWorkOrdersRightBar} />
      </div>
    </>
  );
}

export default RecurringWorkOrders;
